import FeatherIcon from 'feather-icons-react';

import { formatDate, formatTimeToAmPm } from 'services/utils';
import Page from 'components/custom/template/Page';
// import Icon from 'components/icon';
// import apiEndpoints from 'constants/apiEndpoints';
import apiEndpoints from 'constants/apiEndpoints';
import { Icon } from '@iconify/react';
import { getManuallPunchApprovalStatus } from 'helpers/status-badge';
import StatusBadge from 'components/custom/ui/StatusBadge';
import { Link } from 'react-router-dom';
import { hrmsPaths } from 'constants/pagePath';
const EmployeeLatePunchinHistoryColumns = () => {
  return [
    {
      accessorKey: 'employee_name',
      id: 'employee_name',
      header: () => {
        return (
          <div className="d-inline-flex flex-center">
            <div className="px-1 py-1 bg-primary-100 rounded me-2">
              <FeatherIcon
                icon="user"
                size={16}
                className="text-primary-600 dark__text-primary-300"
              />
            </div>
            <span>Name</span>
          </div>
        );
      },
      cell: ({ row: { original } }) => {
        const { employee_name, employee_mobile, user_id } = original;

        return (
          <div className="d-flex align-items-center">
            <div>
              <Link
                to={`${hrmsPaths.employee.detail(user_id)}`}
                className="fs-8 fw-bold"
              >
                {employee_name}
              </Link>

              <div className="d-flex align-items-center">
                <Link
                  className="mb-0 text-1000 fw-semi-bold fs-9 me-2"
                  to={`tel: ${employee_mobile}`}
                >
                  {employee_mobile}
                </Link>
              </div>
            </div>
          </div>
        );
      },
      meta: {
        headerProps: { style: { width: '20%' }, className: 'ps-0 border-end' },
        cellProps: { className: 'white-space-nowrap ps-0 border-end' }
      }
    },
    {
      accessorKey: 'shift_name',
      header: () => {
        return (
          <div className="d-inline-flex flex-center">
            <div className="px-1 py-1 bg-warning-100 rounded me-2">
              <FeatherIcon
                icon="clock"
                size={16}
                className="text-warning-600 dark__text-warning-300"
              />
            </div>
            <span>Shift</span>
          </div>
        );
      },

      cell: ({ row: { original } }) =>
        original.shift_name ? (
          <>
            {original.shift_name} <br />
            <small>
              ({formatTimeToAmPm(original.shift_start_time)} -{' '}
              {formatTimeToAmPm(original.shift_end_time)})
            </small>
          </>
        ) : (
          '--'
        ),
      meta: {
        headerProps: {
          style: { width: '20%' },
          className: 'ps-3 pe-4 '
        },
        cellProps: {
          className: 'white-space-nowrap ps-3  '
        }
      }
    },

    {
      accessorKey: 'punch_in',
      header: () => {
        return (
          <div className="d-inline-flex flex-center">
            <div className="px-1 py-1 bg-warning-100 rounded me-2">
              <FeatherIcon
                icon="clock"
                size={16}
                className="text-warning-600 dark__text-warning-300"
              />
            </div>
            <span>Punch In</span>
          </div>
        );
      },

      cell: ({ row: { original } }) => (
        <>
          {original.punch_in ? (
            <>
              <div> {formatDate(original.punch_in, 'DD MMM YYYY')}</div>
              <div> {formatDate(original.punch_in, 'hh:mm a')}</div>
            </>
          ) : (
            '--'
          )}
        </>
      ),
      meta: {
        headerProps: {
          style: { width: '20%' },
          className: 'ps-3 pe-4 '
        },
        cellProps: {
          className: 'white-space-nowrap ps-3  '
        }
      }
    },

    {
      accessorKey: 'shift_start_time',
      header: () => {
        return (
          <div className="d-inline-flex flex-center">
            <div className="px-1 py-1 bg-danger-100 rounded me-2">
              <Icon
                icon="codicon:sign-in"
                fontSize={16}
                className="text-danger-600 dark__text-danger-300"
              />
            </div>
            <span className="">Late In</span>
          </div>
        );
      },
      cell: ({ row: { original } }) => {
        const { punch_in, shift_start_time } = original;

        if (!punch_in || !shift_start_time) return '--';

        // Convert punch_in to Date object
        const punchInTime = new Date(punch_in);

        // Extract the date part from punch_in
        const datePart = punchInTime.toISOString().split('T')[0];

        // Create a new Date object for shift_start_time using the same date
        const shiftStartTime = new Date(`${datePart}T${shift_start_time}`);

        // Calculate the late duration in minutes
        const lateMinutes = Math.max(
          0,
          Math.floor((punchInTime - shiftStartTime) / (1000 * 60))
        );

        // Function to format the late duration in hours and minutes
        const formatLateDuration = minutes => {
          const hours = Math.floor(minutes / 60);
          const remainingMinutes = minutes % 60;
          return hours > 0
            ? `${hours} Hr ${remainingMinutes} min`
            : `${remainingMinutes} min`;
        };

        // Format the late duration
        const formattedLateTime =
          lateMinutes > 0 ? formatLateDuration(lateMinutes) : '--';

        return (
          <div>
            <div className="text-danger fw-medium">{formattedLateTime}</div>
          </div>
        );
      },
      meta: {
        headerProps: {
          style: { width: '20%' },
          className: 'ps-3 pe-4 '
        },
        cellProps: {
          className: 'white-space-nowrap ps-3  '
        }
      }
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row: { original } }) => {
        const { status } = original;
        const badgeDetail = getManuallPunchApprovalStatus(status);
        return <StatusBadge badgeDetail={badgeDetail} status={status} />;
      },
      meta: {
        headerProps: { className: 'pe-3 text-center' },
        cellProps: {
          className: 'text-center'
        }
      }
    }
  ];
};

const EmployeeLatePunchinHistory = () => {
  return (
    <>
      <Page
        // title={'Approval Location History'}
        // // dummyData={dummyData}
        tableColumn={{
          column: EmployeeLatePunchinHistoryColumns(),
          actions: false
        }}
        // dummyData={dummyData}
        urlEndPoint={apiEndpoints.employee.LatePunchApprovalHistoryList}
        exportName="Employee late Punch-in approval history"
        dataWithDateRange={true}
      >
        {/* {manualPunch.isOpen && (
          <ManualPunchApprovalDetailModal
            show={manualPunch.isOpen}
            handleClose={manualPunch.handleCloseModal}
            data={manualPunch.modalData || {}}
            action={false}
          />
        )} */}
      </Page>
    </>
  );
};

export default EmployeeLatePunchinHistory;
